import React from "react";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../fields/TextInput";

import * as validations from "../../utils/Validation";

let EditForm = props => {
  const { handleSubmit, mode } = props;
  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>
        <section className="form-section">
          <div className="form-section-header">Personal Details</div>

          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">First Name</Label>
              <Field
                name="first_name"
                component={TextInput}
                placeholder="First Name"
                type="text"
                validate={validations.required}
              />
            </FormGroup>

            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Last Name</Label>
              <Field
                name="last_name"
                placeholder="Last Name"
                component={TextInput}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div>
          
          <div className={"row"}>
            <FormGroup className={"col-12 col-sm-6"}>
              <Label>Phone Number</Label>
              <Field
                name={"phone_number"}
                component={TextInput}
                type={"phone"}
                validate={[validations.required, validations.phoneNumber]}
              />
            </FormGroup>
            <FormGroup className={"col-12 col-sm-6"}>
              <Label>Verified</Label>
              <Field
                className={"w-100"}
                name={"verified"}
                component={'input'}
                type={"checkbox"}
                />
            </FormGroup>
          </div>
          
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Email Address</Label>
              <Field
                name="email"
                component={TextInput}
                type="email"
                validate={[validations.required, validations.email]}
              />
            </FormGroup>
          </div>
        </section>

        {mode === "create" && (
          <section className="form-section">
            <div className="form-section-header">Password</div>

            <div className="row">
              <FormGroup className="col-12 col-sm-6">
                <Label htmlFor="firstName">Set a password</Label>
                <Field
                  name="password"
                  component="input"
                  type="password"
                  className="form-control"
                />
              </FormGroup>

              <FormGroup className="col-12 col-sm-6">
                <Label htmlFor="password_confirmation">Confirm password</Label>
                <Field
                  name="password_confirmation"
                  component="input"
                  type="password"
                  className="form-control"
                />
              </FormGroup>
            </div>
          </section>
        )}
      </Form>

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: "EditUserForm"
})(EditForm);

export default EditForm;



// WEBPACK FOOTER //
// ./src/system/containers/Users/Form.jsx